module.exports = __webpack_public_path__ + "img/catchupEnabled.8a485a.svg";